<div class="flex wrap" [ngClass]="{ center: justifyCenter }">
  <ng-content></ng-content>
</div>
